/**
 * Guarda o destino pretendido para retomar APÓS o login — sobrevive ao
 * redirecionamento de página inteira do OAuth do Google (que volta sempre
 * para a origem "/"). Para login por e-mail o `location.state.de` já basta;
 * aqui é o reforço que cobre o caso do Google.
 */
const CHAVE = 'redirect_pos_login';

export function salvarRedirecionamento(path: string | null | undefined): void {
  try {
    if (path && path !== '/') sessionStorage.setItem(CHAVE, path);
  } catch { /* sessionStorage indisponível — ignora */ }
}

/** Lê sem remover (para decidir o render sem efeito colateral). */
export function lerRedirecionamento(): string | null {
  try {
    return sessionStorage.getItem(CHAVE);
  } catch {
    return null;
  }
}

/** Lê e remove (consome de fato, ao navegar). */
export function consumirRedirecionamento(): string | null {
  try {
    const v = sessionStorage.getItem(CHAVE);
    if (v) sessionStorage.removeItem(CHAVE);
    return v;
  } catch {
    return null;
  }
}
